<template>
  <div class="tag-info" v-if="value._id">
    <div class="tag-info__inner">

      <div class="tag-info__col tag-info__col--small">
        <div v-if="value.type !== 'slide'" class="tag-info__block">
          <label>Type</label>
          <select v-model="value.type">
            <option value="basic">Basic</option>
            <option value="box">Box</option>
            <option value="feature">Feature</option>
            <option value="rich">Rich</option>
            <option value="reference">Reference</option>
            <option value="trail">Trail</option>
          </select>
        </div>
        <div class="tag-info__block">
          <label>Label</label>
          <input
            v-model="value.label[lang]"
            type="text"
            placeholder="label"
          />
        </div>
        <div v-if="value.pos" class="tag-info__block tag-info__block--inline">
          <label>X</label>
          <input type="number" v-model.number="value.pos.x" />
        </div>
        <div v-if="value.pos" class="tag-info__block tag-info__block--inline">
          <label>Y</label>
          <input type="number" v-model.number="value.pos.y" />
        </div>
        <div v-if="value.pos" class="tag-info__block tag-info__block--inline tag-info__block--inactive">
          <label>W</label>
          <input type="text" v-model.number="width" readonly />
        </div>
        <div v-if="value.pos" class="tag-info__block tag-info__block--inline tag-info__block--inactive">
          <label>H</label>
          <input type="text" v-model.number="height" readonly />
        </div>
        <div v-if="['slide'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Should slide expand</label>
          <toggle-button
            v-model="value.shouldSlideExpand"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>
      </div>

      <div class="tag-info__col tag-info__col--big element-grow">
        <div v-if="['box'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>distance</label>
          <input
            v-model="value.distance[lang]"
            type="text"
            placeholder="distance"
          />
        </div>
        <div v-if="['box'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Arrow degrees</label>
          <input
            v-model.number="value.arrowDeg"
            type="number"
            placeholder="arrow degrees"
          />
        </div>
        <div v-if="['box', 'trail'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Icon Code 
            <fa v-if="value.icon" :icon="['fad', value.icon]"/>
          </label>
          <select v-model="value.icon">
            <option value=""></option>
            <option value="bicycle">Bicycle</option>
            <option value="bus">Bus</option>
            <option value="car">Car</option>
            <option value="motorcycle">Motorcycle</option>
            <option value="ship">Ship</option>
            <option value="subway">Subway</option>
            <option value="taxi">Taxi</option>
            <option value="train">Train</option>
            <option value="walking">Walking</option>
            <option value="wheelchair">Wheelchair</option>
          </select>
        </div>
        <div v-if="['rich', 'reference'].indexOf(value.type) !== -1" class="tag-info__block element-grow">
          <label>description</label>
          <textarea
            v-model="value.description[lang]"
            class="element-grow"
            rows="3"
            placeholder="description"
          ></textarea>
        </div>
        <div v-if="['rich'].indexOf(value.type) !== -1" class="tag-info__block element-grow">
          <label>More Information</label>
          <textarea
            v-model="value.moreInformation[lang]"
            class="element-grow"
            rows="3"
            placeholder="more information"
          ></textarea>
        </div>
        <div v-if="['reference'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Hide the reference tag</label>
          <toggle-button 
            v-model="value.hideTagReference" 
            color="#28a745" 
            :sync="true" 
            :labels="false" 
            :width="40" 
            :height="20" 
            style="font-weight: 400"
          />
        </div>
        <div v-if="['basic', 'rich', 'reference', 'feature'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Tail Position</label>
          <select v-model="value.tailPosition">
            <option value="">No Tail</option>
            <option v-if="value.type !== 'reference'" value="bottom-left">Bottom Left</option>
            <option value="bottom-center">Bottom Center</option>
            <option v-if="value.type !== 'reference'" value="bottom-right">Bottom Right</option>
            <option v-if="value.type !== 'reference'" value="top-left">Top Left</option>
            <option value="top-center">Top Center</option>
            <option v-if="value.type !== 'reference'" value="top-right">Top Right</option>
            <option value="left-center">Left Center</option>
            <option value="right-center">Right Center</option>
          </select>
        </div>
        <div v-if="['rich'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Flip</label>
          <toggle-button 
            v-model="value.flip" 
            color="#28a745" 
            :sync="true" 
            :labels="false" 
            :width="40" 
            :height="20" 
            style="font-weight: 400"
          />
        </div>
        <div v-if="['basic'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Highlight Tag</label>
          <toggle-button 
            v-model="value.isHighlighted" 
            color="#28a745" 
            :sync="true" 
            :labels="false" 
            :width="40" 
            :height="20" 
            style="font-weight: 400"
          />
        </div>

        <div v-if="value.type === 'slide'" class="tag-info__col tag-info__col--big">
          <div class="tag-info__block">
            <label>Background Image Override</label>
            <input-asset v-model="value.backgroundImageOverride" defaultCategory="tagImage"></input-asset>
          </div>
        </div>
      </div>

      <div v-if="['rich', 'reference'].indexOf(value.type) !== -1" class="tag-info__col tag-info__col--big">
        <div class="tag-info__block">
          <label>Asset</label>
          <input-asset :returnid="true" v-model="value.assetId" defaultCategory="tagImage"></input-asset>
        </div>
      </div>

      <div v-if="value.type === 'slide'" class="tag-info__col tag-info__col--big">
        <div class="tag-info__block">
          <label>Slide Media</label>
          <input-asset :returnid="true" v-model="value.assetId" defaultCategory="tagImage"></input-asset>
        </div>
      </div>

      <div class="tag-info__col tag-info__col--last">
        <button class="btn btn-danger" @click="remove">Remove</button>
      </div>
    </div>
  </div>
</template>

<script>
import InputAsset from '@/components/InputAsset'

export default {
  name: 'tag-info-box',

  components: {
    InputAsset
  },

  props: ['value', 'lang'],

  data () {
    return {
      height: 0,
      width: 0
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: false,
      handler () {
        this.updateTagSize()
      }
    }
  },

  methods: {
    remove () {
      this.$emit('remove')
    },

    updateTagSize () {
      const el = document.getElementById(this.value._id)
      if (el) {
        this.height = Math.round(el.getBoundingClientRect().height / this.$attrs.scale)
        this.width = Math.round(el.getBoundingClientRect().width / this.$attrs.scale)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";

.tag-info {
  background: rgba(255, 255, 255, 0.95);
  bottom: 0;
  padding: 10px 15px;
  position: relative;
  right: 0;
  width: 100%;
  z-index: 100;

  @include breakpoint(1800px) {
    bottom: 0;
    height: 100%;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: calc(20% - 15px);

    .tag-info__inner {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
    }
  }

  &__inner {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
  }

  &__col {
    display: flex;
    flex-direction: column;
    margin: 0 20px 5px 0;
    width: 100%;

    @include breakpoint(1800px) {
      margin: 0 0 5px 0;
    }

    &--small {
      max-width: 200px;

      @include breakpoint(1800px) {
        max-width: 100%;
      }
    }

    &--big {
      max-width: 300px;

      @include breakpoint(1800px) {
        max-width: 100%;
      }
    }

    &--grow {
      flex-grow: 1;
    }

    &--last {
      margin: auto 0 0 auto;
      max-width: 160px;

      @include breakpoint(1800px) {
        max-width: 100%;
      }
    }
  }

  &__block {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    &--grow {
      flex-grow: 1;
    }

    label {
      font-size: .85em;
      margin: 0;
      text-transform: capitalize;
    }

    input {
      background: transparent;
      border: none;
      border-bottom: 1px solid gray;
      box-sizing: border-box;
      padding: 2px;
      width: 100%;
    }

    textarea {
      background: transparent;
      border: 1px solid grey;
      border-radius: 2px;
      padding: 2px;
      width: 100%;
    }

    &--inline {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      input {
        width: calc(100% - 20px);
      }
    }

    &--inactive {
      input {
        border: none;
        cursor: default;
      }
    }
  }
}

.element-grow {
  flex-grow: 1;
}

.input-asset {
  width: 100%;
}
</style>